import { useEffect, useMemo, useState } from 'react';

import { useGetRegisteredDevices } from '@/features/notifications/hooks/useGetRegisteredDevices';
import { checkPermissions } from '@/features/notifications/utils/pushNotifications';
import { useGetMyUser } from '@/features/users/hooks/useGetMyUser';
import { isNativePlatform } from '@/shared/utils/platform';

export function useIsPlayNowToggleEnabled() {
  const { data: createdAt } = useGetMyUser({
    options: {
      select: data => data.user.createdAt,
    },
  });
  const { data: devices } = useGetRegisteredDevices({
    options: {
      select: data => data.devices,
    },
  });

  const isFirstDay = useMemo(() => {
    if (!createdAt) return false;
    const createdAtDate = new Date(createdAt);
    const now = new Date();
    const diffInHours =
      (now.getTime() - createdAtDate.getTime()) / (1000 * 60 * 60);
    return diffInHours < 24;
  }, [createdAt]);

  // For native platforms: check permissions directly
  const [hasNativePermissions, setHasNativePermissions] = useState(false);

  useEffect(() => {
    if (isNativePlatform()) {
      void checkPermissions().then(setHasNativePermissions);
    }
  }, []);

  // For web: check if there's a native device registered (old logic)
  const hasNativeDevice = useMemo(() => {
    if (isNativePlatform()) return false; // Not used on native
    if (!devices) return false;
    return devices.some(
      device => device.platform === 'IOS' || device.platform === 'ANDROID',
    );
  }, [devices]);

  const isEnabled = isNativePlatform() ? hasNativePermissions : hasNativeDevice;

  return isEnabled || isFirstDay;
}
